import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

const routes = [
    {
        path: "/login",
        name: "login",
        component: () => import("./views/Login")
    },
    {
        path: "/",
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/home",
        name: "home",
        meta: {
            requiresAuth: true
        },
    },

    //Customer Support
    {
        path: "/customer-support/venue-hire",
        name: "support-venue-hire",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/CustomerService/VenueHire/VenueHireTable.vue")
    },
    {
        path: "/customer-support/venue-hire/edit",
        name: "support-venue-hire-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/CustomerService/VenueHire/VenueHireEdit.vue")
    },
    {
      path: "/customer-support/group-visit",
      name: "support-group-visit",
      meta: {
            requiresAuth: true
        },
        component: () => import("./views/CustomerService/GroupVisit/GroupVisitTable.vue")
    },
    {
      path: "/customer-support/group-visit/edit",
      name: "support-group-visit-edit",
      meta: {
            requiresAuth: true
        },
        component: () => import("./views/CustomerService/GroupVisit/GroupVisitEdit.vue")
    },
    {
        path: "/customer-support/contact",
        name: "support-contact",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/CustomerService/Contact/ContactTable.vue")
    },
    {
        path: "/customer-support/contact/edit",
        name: "support-contact-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/CustomerService/Contact/ContactEdit.vue")
    },
    //branch
    {
        path: "/branch/main-branch",
        name: "main-branch",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Branch/MainBranch/MainBranchTable.vue")
    },
    {
        path: "/branch/edit",
        name: "main-branch-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Branch/MainBranch/MainBranchEdit.vue")
    },
    {
        path: "/branch/mini-tcdc",
        name: "mini-tcdc",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Branch/MiniTCDC/MiniTCDCTable.vue")
    },
    {
        path: "/mini-tcdc/edit",
        name: "mini-tcdc-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Branch/MiniTCDC/MiniTCDCEdit.vue")
    },
    {
        path: "/tcdc-mini-type/edit",
        name: "tcdc-mini-type-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Branch/MiniType/MiniTypeEdit.vue")
    },
    {
        path: "/branch/tcdc-mini-type",
        name: "tcdc-mini-type",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Branch/MiniType/MiniTypeTable")
    },
    //service menu
    {
        path: "/services/service",
        name: "service",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/Service/ServiceTable.vue")
    },
    {
        path: "/service/edit",
        name: "service-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/Service/ServiceEdit.vue")
    },
    {
        path: "/services/service-area",
        name: "service-area",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/ServiceArea/ServiceAreaTable.vue")
    },
    {
        path: "/services-area/edit",
        name: "service-area-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/ServiceArea/ServiceAreaEdit.vue")
    },
    {
        path: "/services/venue-hire",
        name: "venue-hire",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/VenueHire/VenueHireTable.vue")
    },
    {
        path: "/venue-hire/edit",
        name: "venue-hire-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/VenueHire/VenueHireEdit.vue")
    },
    {
        path: "/services/venue-hire-details",
        name: "venue-hire-details",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/VenueHireDetails/VenueHireDetailsTable")
    },
    {
        path: "/venue-hire-details/edit",
        name: "venue-hire-details-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/VenueHireDetails/VenueHireDetailsEdit.vue")
    },
    {
        path: "/services/group-visit",
        name: "group-visit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/GroupVisit/GroupVisitTable")
    },
    {
        path: "/group-visit/edit",
        name: "group-visit-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/GroupVisit/GroupVisitEdit")
    },
    {
        path: "/services/travel-info",
        name: "travel-info",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/TravelInfo/TravelInfoTable")
    },
    {
        path: "/travel-info/edit",
        name: "travel-info-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/TravelInfo/TravelInfoEdit")
    },
    {
        path: "/services/restaurant",
        name: "restaurant",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/Restaurant/RestaurantTable")
    },
    {
        path: "/restaurant/edit",
        name: "restaurant-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/Restaurant/RestaurantEdit")
    },
    {
        path: "/services/floor",
        name: "floor",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/Floor/FloorTable")
    },
    {
        path: "/floor/edit",
        name: "floor-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Services/Floor/FloorEdit")
    },
    //membership
    {
        path: "/membership",
        name: "membership",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Membership/Membership/MembershipTable")
    },
    {
        path: "/membership/edit",
        name: "membership-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Membership/Membership/MembershipEdit")
    },
    {
        path: "/membership/membership-rate",
        name: "membership-rate",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Membership/MembershipRate/MembershipRateTable")
    },
    {
        path: "/membership-rate/edit",
        name: "membership-rate-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Membership/MembershipRate/MembershipRateEdit")
    },
    {
        path: "/membership/membership-benefit",
        name: "membership-benefit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Membership/MembershipBenefit/MembershipBenefitTable")
    },
    {
        path: "/membership-benefit/edit",
        name: "membership-benefit-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Membership/MembershipBenefit/MembershipBenefitEdit")
    },
    {
        path: "/membership/members",
        name: "members",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Membership/Members/MemberTable")
    },
    {
        path: "/members/edit",
        name: "members-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Membership/Members/MemberEdit")
    },
    //menu
    {
        path: "/menu/menu",
        name: "menu",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Menus/Menu/MenuTable")
    },
    {
        path: "/menu/edit",
        name: "menu-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Menus/Menu/MenuEdit")
    },
    {
        path: "/menu/sub-menu",
        name: "sub-menu",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Menus/SubMenu/SubMenuTable")
    },
    {
        path: "/sub-menu/edit",
        name: "sub-menu-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Menus/SubMenu/SubMenuEdit")
    },
    //about
    {
        path: "/about/about",
        name: "about",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/AboutTable")
    },
    {
        path: "/about/edit",
        name: "about-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/AboutEdit")
    },
    {
        path: "/about/network",
        name: "network",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/Network/NetworkTable")
    },
    {
        path: "/network/edit",
        name: "network-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/Network/NetworkEdit")
    },
    {
        path: "/about/location",
        name: "location",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/Location/LocationTable")
    },
    {
        path: "/location/edit",
        name: "location-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/Location/LocationEdit")
    },
    {
        path: "/about/news",
        name: "news",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/News/NewsTable")
    },
    {
        path: "/news/edit",
        name: "news-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/News/NewsEdit")
    },
    {
        path: "/about/partner",
        name: "partner",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/Partner/PartnerTable")
    },
    {
        path: "/partner/edit",
        name: "partner-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/Partner/PartnerEdit")
    },
    {
        path: "/about/sponser-program",
        name: "sponser-program",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/SponserProgram/SponserProgramTable")
    },
    {
        path: "/sponser-program/edit",
        name: "sponser-program-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/SponserProgram/SponserProgramEdit")
    },
    {
        path: "/about/contact",
        name: "contact",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/Contact/ContactTable")
    },
    {
        path: "/contact/edit",
        name: "contact-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/About/Contact/ContactEdit")
    },
    //design world calendar
    {
        path: "/design-world-calendar",
        name: "design-world-calendar",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/DesignWorldCalendar/DesignWorldCalendarTable")
    },
    {
        path: "/design-world-calendar/edit",
        name: "design-world-calendar-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/DesignWorldCalendar/DesignWorldCalendarEdit")
    },
    //resource center
    {
        path: "/resource-center",
        name: "resource-center",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/ResourceCenter/ResourceCenterTable")
    },
    {
        path: "/resource-center/edit",
        name: "resource-center-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/ResourceCenter/ResourceCenterEdit")
    },
    {
        path: "/online-exhibition",
        name: "online-exhibition",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/ResourceCenter/OnlineExhibition/OnlineExhibitionTable")
    },
    {
        path: "/online-exhibition/edit",
        name: "online-exhibition-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/ResourceCenter/OnlineExhibition/OnlineExhibitionEdit")
    },
    //faq
    {
        path: "/fag/faqs",
        name: "faq",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Faq/FaqTable")
    },
    {
        path: "/faqs/edit",
        name: "faq-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Faq/FaqEdit")
    },
    {
        path: "/faq/faq-category",
        name: "faq-category",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Faq/FaqCategoryTable")
    },
    {
        path: "/faq-category/edit",
        name: "faq-category-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Faq/FaqCategoryEdit")
    },
    {
        path: "/banner",
        name: "banner",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Banner/BannerTable")
    },
    {
        path: "/banner/edit",
        name: "banner-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/Banner/BannerEdit")
    },
    {
        path: "/landing-page",
        name: "landing-page",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/LandingPage/LandingPageTable")
    },
    {
        path: "/landing-page/edit",
        name: "landing-page-edit",
        meta: {
            requiresAuth: true
        }, component: () => import("./views/LandingPage/LandingPageEdit")
    },
];
export default routes;
